module.exports = __webpack_public_path__ + "img/5.01becc78.jpg";